(function (angular) {
  var classOnValueDirective = "pcmClassOnValue";

  angular
    .module("app")
    .directive(classOnValueDirective,
      function () {
        return {
          require: "ngModel",
          link: function (scope, element, attrs, ngModel) {
            scope.$watch(function () {
              return ngModel.$viewValue;
            }, function (newValue, oldValue) {
              if ((newValue !== "") && (newValue != null)) {
                element.addClass(attrs.pcmClassOnValue);
              } else {
                element.removeClass(attrs.pcmClassOnValue);
              };
            });
          }
        };
      });

})(angular);



// WEBPACK FOOTER //
// ./app/components/classOnValue.directive.js